import postCategoryBarView from './postCategoryBarComponent.html';
import './postCategoryBarComponent.css';
import _ from 'lodash';
import { ensure } from 'components/sharpr/ensure/ensure';

export function postCategoryBarComponent() {
	return {
		bindings: {
			search: '=',
			onAfterChange: '&?',
			layout: '=',
			recalculateOverflow: '<?',
		},
		transclude: true,
		controllerAs: 'vm',
		controller: postCategoryBarComponentCtrl,
		template: postCategoryBarView,
	};
}

export class postCategoryBarComponentCtrl {
	constructor(Api, Cfg, Taxonomy, $element, $timeout, $scope) {
		'ngInject';
		this.$element = $element;
		this.$timeout = $timeout;
		this.overflowCount = 0;
		this.Api = Api;
		this.Cfg = Cfg;
		this.Taxonomy = Taxonomy;
		this.showMultiHub = parseInt(this.Cfg.read('Search.show_multihub'), 10) === 1;
		this.getCategories();
		this.throttledRecount = _.throttle(this.recount.bind(this), 50, {
			leading: false,
			trailing: true,
		});
		this.isMoreOpen = false;
		this.setCategory = this.setCategory.bind(this);
		this.allItemEl = this.$element[0].querySelector('.all-item');
		$scope.$watch('vm.recalculateOverflow', () => {
			// `vm.recalculateOverflow` happens in the parent when posts are added to the page. That can cause the
			/// vertical scroll bar to appear, which changes the width of the page and requires a recount. But the
			/// new width isn't accessible to javascript right away, hence the timeout.
			this.$timeout(() => this.recount(), 100);
		});
		$scope.$watch('vm.search.multihub', this.getCategories.bind(this));
	}

	$onInit() {
		angular.element(window).on('resize', this.throttledRecount.bind(this));
	}
	$onDestroy() {
		angular.element(window).off('resize', this.recount);
	}

	// get the set of categories that belongs to the currently selected hubs
	getCategories() {
		const getter =
			ensure.object(this.search).multihub && ensure.string(this.search.multihub).length
				? this.Api.get('/categories', null, { Hubs: this.search.multihub })
				: this.Taxonomy.getCategories();
		getter.then(data => {
			this.processCategories(data);
			this.$timeout(() => this.recount(), 200);
		});
	}

	processCategories(categories) {
		this.mainCategories = [];
		this.activeCategories = [];
		let partition = false;
		// categories listed after a hub's `-----` category do not show in the bar. They only show in the more dropdown.
		ensure.array(categories).forEach(cat => {
			// skip existing
			if (_.find(this.activeCategories, { name: cat.name })) {
				return;
			}
			cat.search = cat.name;
			if (!cat.is_active) {
				return;
			} else if (cat.name === '-----') {
				partition = true;
				return;
			} else if (!partition) {
				// categories before the partition go here
				this.mainCategories.push(cat);
			}
			// all active categories go here
			this.activeCategories.push(cat);
		});
	}

	setCategory(category) {
		this.search.categories = [category.name];
		if (this.onAfterChange) {
			this.onAfterChange();
		}
	}

	clearCategory() {
		if (this.search.categores) {
			this.search.categories.length = 0;
		} else {
			this.search.categories = [];
		}
		if (this.onAfterChange) {
			this.onAfterChange();
		}
	}

	recount() {
		this.overflowCount = this._getOverflowCount();
		this.$timeout(() => {});
	}

	/**
	 * Calculates the number of categories that are outside of the category bar's available width.
	 * @returns {number}
	 * @private
	 */
	_getOverflowCount() {
		let categories = this.$element[0].querySelectorAll('.category');
		// make sure we have an array (for IE11 only)
		categories = [...categories];
		if (!this.allItemEl) {
			this.allItemEl = this.$element[0].querySelector('.all-item');
		}
		if (categories.length <= 1 || !this.allItemEl) {
			return 0;
		}
		// 1. get width of bar
		const categoryBarInnerEl = this.$element[0].querySelector('.page-toolbar-main');
		const categoryBarInnerElWidth = categoryBarInnerEl.offsetWidth;
		// the combined width always starts with the width of the ALL button
		let combinedCatWidth = this.allItemEl.clientWidth;
		// overflowCount increases once the combined width is greater than the category bar's inner width
		let overflowCount = 0;
		// 2. sum each category item's width. If there are still categories after the bar width is reached, they
		/// are overflow categories.
		categories.forEach(el => {
			combinedCatWidth += el.offsetWidth;
			// `+ 2`: in Chrome, the final category item may wrap to next line even though there is enough room in the
			/// category bar. I added `+ 2` to handle that situation so it will be greater if it is very close.
			const willHide = combinedCatWidth + 2 > categoryBarInnerElWidth;
			el.style.visibility = willHide ? 'hidden' : 'visible';
			overflowCount += willHide ? 1 : 0;
		});
		return overflowCount;
	}
}
